<template>
  <li class="user-notifications-list-item" :disabled="disabled" v-on="$listeners">
    <div class="list-item-icon">
      <svg-loader :src="`/assets/images/icon-${icon}.svg`" />
    </div>

    <div class="list-item-content">
      <strong class="list-item-title">{{ title }}</strong>
      <span class="list-item-description" v-if="description">{{ description }}</span>
      <span class="list-item-date" v-if="date">{{ date }}</span>
    </div>
  </li>
</template>

<script>
  export default {
    name: 'UserNotificationsListItem',
    props: {
      icon: String,
      title: String,
      description: String,
      date: String,
      disabled: Boolean
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta';

  .user-notifications-list-item {
    padding: 15px;
    display: flex;
    border-top: 1px solid transparent;
    transition: .3s $transition-default;

    &:focus-visible {
      outline: -webkit-focus-ring-color auto 1px;
    }

    + .user-notifications-list-item {
      border-top-color: $color-light-grey;
    }

    &:not([disabled]) {
      cursor: pointer;

      &:hover {
        background-color: $color-light-grey;
        border-top-color: $color-grey;

        + .user-notifications-list-item {
          border-top-color: $color-grey;
        }
      }

      &:active {
        background-color: $color-grey;
        border-top-color: darken($color-grey, 3%);

        + .user-notifications-list-item {
          border-top-color: darken($color-grey, 3%);
        }
      }
    }
  }

  .list-item-icon {
    width: 36px;
    height: 36px;
    margin-right: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: .3s $transition-default;

    svg {
      transition: .3s $transition-default;
    }
  }

  .list-item-content {
    display: block;
    flex-direction: column;
    flex: 1;
    color: $color-darker-grey;
  }

  .list-item-title,
  .list-item-description,
  .list-item-date {
    font-size: 12px;
    line-height: 1.33em;
  }

  .list-item-title {
    color: $color-tundora;
  }

  .list-item-date {
    margin-top: 4px;
    display: block;
    color: $color-dark-grey;
  }
</style>
